/* Disabled fields for phase 1 */
import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import NumberFormat from "react-number-format";
import {
  itemServices,
  globalServices,
  posServices,
  storeService,
} from "../../Services";
import Tooltip from "../Common/Tooltip";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import { roles } from "../../Config/Roles";
import NullTaxRateModal from "./NullTaxRateModal";
import { Modal } from "react-bootstrap";

const initState = {
  createInAllPriceLists: false,
  name: "",
  code: "",
  barCode: "",
  description: "",
  isService: false,
  pn: null,
  unitOfMeasureId: -1,
  taxRateId: -1,
  itemId: -1,
  price: null,
  pp: null,
  itemGroupId: -1,
  isRawMaterial: false,
};

const AddItemModal = ({ itemId, priceListId, show, handleClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { locName, locTenant, locStore, locPos, locTab } =
    useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { cashier, manager, accountant } = roles;
  //    const priceListId = match.params.priceListId;
  //    const itemId = match.params.itemId;

  const history = useHistory();
  const { t: translator } = useTranslation();

  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [item, setItem] = useState(initState);
  const [taxRates, setTaxRates] = useState([]);
  const [unitOfMeasures, setUnitOfMeasures] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [showNullTaxRate, setShowNullTaxRate] = useState(false);
  const [tenantTaxObligation, setTenantTaxObligation] = useState(false);
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  React.useEffect(() => {
    if (locPos != 0) {
      posServices
        .getById(locPos)
        .then((res) => {
          setTenantTaxObligation(res.data.tenantTaxObligation);
        })
        .catch((err) => setTenantTaxObligation(false));
    } else {
      storeService
        .getById(locStore)
        .then((res) => setTenantTaxObligation(res.data.tenantTaxObligation))
        .catch((err) => setTenantTaxObligation(false));
    }

    if ([cashier, manager, accountant].includes(Number(roleId)))
      history.push("/error-page/401");
    globalServices.getTaxRates().then((res) => setTaxRates(res.data));

    globalServices
      .getUnitOfMeasures()
      .then((res) => setUnitOfMeasures(res.data));

    globalServices.getItemGroups(Number(locTenant)).then((res) => {
      setItemGroups(res.data);
    });
    if (itemId) {
      setIsLoading(true);
      itemServices
        .getById(locTab === "rawMaterials" ? 0 : priceListId, itemId)
        .then((data) => {
          setItem({
            itemId: data.data.itemId,
            priceListItemId: data.data.priceListItemId,
            name: data.data.name,
            barCode: data.data.barCode,
            code: data.data.code,
            description: data.data.description,
            isService: data.data.isService,
            itemGroupId: data.data.itemGroupId,
            pn: data.data.pn,
            pp: data.data.pp,
            price: data.data.price,
            taxRateId: data.data.taxRateId,
            unitOfMeasureId: data.data.unitOfMeasureId,
            isRawMaterial: data.data.isRawMaterial,
          });
          setIsLoading(false);
        });
    }
  }, [itemId]);

  const checkPrice = () => {
    if (document.getElementsByName("isRawMaterial")[0].checked) {
      return true;
    }
    return document.getElementById("priceInput").value != "";
  };

  const handleChangeRawMaterial = () => {
    if (item.isService) {
      setItem({
        ...item,
        isService: false,
        isRawMaterial: !item.isRawMaterial,
      });
    } else setItem({ ...item, isRawMaterial: !item.isRawMaterial });
  };

  const handleIsServiceChange = (event) => {
    if (item.isRawMaterial) {
      setItem({ ...item, isService: false });
    } else setItem({ ...item, isService: !item.isService });
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    handleClose();
    if (resultModal.success === true) {
      goBack();
    }
  };

  const onSubmit = (data) => {
    if (itemId) {
      itemServices
        .update({
          itemId: itemId,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: data.code,
          barCode: data.barCode,
          description: data.description,
          isService: item.isService,
          pn: data.pnInput
            ? parseFloat(convertToDecimalString(data.pnInput))
            : null,
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId:
            Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
          changePriceByTaxRate: false,
          itemGroupId: data.itemGroupId,
          priceListItemId: item.priceListItemId,
          price: parseFloat(convertToDecimalString(data.priceInput)),
          pp: parseFloat(data.pp),
          isRawMaterial: item.isRawMaterial,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItem-UpdateItem-SuccesModal-Title"),
                text: translator("EditItem-UpdateItem-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItem-Update-UnsuccessModal-Title"),
                text: translator("EditItem-Update-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItem-Update-UnsuccessModal-Title"),
            text: translator("EditItem-Update-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    } else {
      itemServices
        .create({
          tenantId: locTenant && Number(locTenant),
          createInAllPriceLists: false,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: data.code,
          barCode: data.barCode,
          description: data.description,
          isService: item.isService,
          pn: data.pnInput
            ? parseFloat(convertToDecimalString(data.pnInput))
            : null,
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId:
            Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
          itemGroupId: data.itemGroupId,
          price: parseFloat(convertToDecimalString(data.priceInput)),
          pp: Number(data.pp),
          isRawMaterial: item.isRawMaterial,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItem-AddNewItem-SuccesModal-Title"),
                text: translator("EditItem-AddNewItem-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItem-Add-UnsuccessModal-Title"),
                text: translator("EditItem-Add-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItem-Add-UnsuccessModal-Title"),
            text: translator("EditItem-Add-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    goBack();
  };

  const goBack = () => {
    switch (locName) {
      case "stores":
        history.push(`/${locName}/${locStore}`);
        break;
      case "pos":
        history.push(`/${locName}/${locPos}`);
        break;
      default:
        history.push("/error");
    }
  };

  return (
    <Modal size="xl" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {itemId
            ? translator("EditItem-Subtitle-UpdateArticle")
            : translator("EditItem-Subtitle-NewArticle")}
        </Modal.Title>
      </Modal.Header>
      {/* <CardWrap
            title={translator("EditItem-Title-ItemManagement")}
            subtitle={
               itemId
                  ? translator("EditItem-Subtitle-UpdateArticle")
                  : translator("EditItem-Subtitle-NewArticle")
            }
         > */}
      {tenantTaxObligation == false ? (
        <div
          style={{ margin: 5, marginBottom: "20px" }}
          className="alert alert-warning"
          role="alert"
        >
          {translator("Tenant-FiscalObligation")}
        </div>
      ) : (
        ""
      )}

      {isLoading && <SpinnerLoading />}
      {!isLoading && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-ArticleData")}
                </legend>
                <div className="form-group">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="isRawMaterial"
                      defaultChecked={item.isRawMaterial}
                      onChange={handleChangeRawMaterial}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("EditItem-RawMaterial")}</span>{" "}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-Name")}</label>{" "}
                  <Tooltip text={translator("Item-Name-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    ref={register({ required: true, maxLength: 100 })}
                    defaultValue={item.name}
                  />
                  {errors.name && errors.name.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.name && errors.name.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength100")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-ItemGroup")}
                  </label>
                  <select
                    name="itemGroupId"
                    ref={register({
                      validate: (value) => item.isRawMaterial || value !== "-1",
                    })}
                    className="form-control"
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    {itemGroups &&
                      itemGroups.map((g) => (
                        <option
                          key={g.id}
                          selected={item.itemGroupId === g.id}
                          value={g.id}
                        >
                          {g.name}
                        </option>
                      ))}
                  </select>
                  {errors.itemGroupId &&
                    errors.itemGroupId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-UnitOfMeasure")}
                  </label>{" "}
                  <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                  <select
                    name="unitOfMeasureId"
                    ref={register({
                      validate: (value) => value !== "-1",
                    })}
                    className="form-control"
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    {unitOfMeasures &&
                      unitOfMeasures.map((x) => (
                        <option
                          selected={item.unitOfMeasureId === x.id}
                          value={x.id}
                        >
                          {x.name}
                        </option>
                      ))}
                  </select>
                  {errors.unitOfMeasureId &&
                    errors.unitOfMeasureId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>

                <div style={{ marginTop: "40px" }} className="form-group">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="isProduct"
                      checked={!item.isService}
                      onChange={handleIsServiceChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("EditItem-Product")}</span>{" "}
                  <Tooltip text={translator("Item-Product-Msg")} />
                  <label style={{ marginLeft: "30px" }} className="labelCont">
                    <input
                      type="checkbox"
                      name="isService"
                      checked={item.isService && !item.isRawMaterial}
                      onChange={handleIsServiceChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("EditItem-Service")}</span>
                </div>
              </fieldset>
            </div>

            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-TaxInformation")}
                </legend>
                <div className="form-group">
                  <strong>
                    {" "}
                    <label>{translator("EditItem-Price")}</label>{" "}
                    <Tooltip text={translator("Item-Price-Msg")} />
                  </strong>
                  <div className="input-group">
                    <Controller
                      name="priceInput"
                      control={control}
                      rules={{
                        validate: checkPrice,
                        maxLength: 14,
                      }}
                      as={
                        <NumberFormat
                          id="priceInput"
                          thousandSeparator={" "}
                          decimalSeparator={","}
                          allowNegative={false}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          placeholder={"0,00"}
                          inputMode="numeric"
                          className="form-control"
                          //disabled={Boolean(useAccounting) && Boolean(itemId)}
                          disabled={item.isRawMaterial}
                        />
                      }
                      defaultValue={item.price}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        EUR
                      </span>
                    </div>
                  </div>
                  {errors.priceInput &&
                    errors.priceInput.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.priceInput &&
                    errors.priceInput.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PriceInput")}
                      </p>
                    )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-TaxRate")}
                  </label>{" "}
                  <Tooltip text={translator("Item-TaxRate-Msg")} />
                  <select
                    ref={register}
                    name="taxRateId"
                    onChange={(e) => {
                      if (e.target.value == 0) {
                        setShowNullTaxRate(true);
                      } else {
                        setShowNullTaxRate(false);
                      }
                    }}
                    className="form-control"
                    disabled={
                      tenantTaxObligation == false ||
                      //Boolean(itemId) ||
                      item.isRawMaterial
                    }
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    <option value={0}>{translator("NullTaxRate")}</option>
                    {taxRates &&
                      taxRates.map((x) => (
                        <option selected={item.taxRateId === x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                  {errors.taxRateId && errors.taxRateId.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>

                <div className="form-group">
                  <label>{translator("EditItem-Refunds")}</label>{" "}
                  <Tooltip text={translator("Item-Refunds-Msg")} />
                  <div className="input-group">
                    <Controller
                      name="pnInput"
                      control={control}
                      rules={{
                        validate: function (value) {
                          if (
                            value === "" ||
                            value == null ||
                            value === "0,00" ||
                            value === "0,10" ||
                            item.isRawMaterial
                          ) {
                            return true;
                          } else return false;
                        },
                      }}
                      as={
                        <NumberFormat
                          thousandSeparator={" "}
                          decimalSeparator={","}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          placeholder={"0,00"}
                          inputMode="numeric"
                          className="form-control"
                          disabled={item.isRawMaterial}
                        />
                      }
                      defaultValue={item.pn}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        EUR
                      </span>
                    </div>
                  </div>
                  {errors.pnInput && errors.pnInput.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PN")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-ConsummationTax")}</label>{" "}
                  <Tooltip text={translator("Item-ConsummationTax-Msg")} />
                  <div className="input-group">
                    <input
                      type="number"
                      min="0"
                      step=".01"
                      className="form-control"
                      name="pp"
                      disabled={item.isRawMaterial}
                      ref={register({
                        required: !item.isRawMaterial,
                        min: 0,
                        max: 3,
                      })}
                      defaultValue={item.pp}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        %
                      </span>
                    </div>
                  </div>
                  {errors.pp && errors.pp.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.pp &&
                    (errors.pp.type === "min" || errors.pp.type === "max") && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PP")}
                      </p>
                    )}
                </div>
              </fieldset>
            </div>
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-OtherData")}
                </legend>

                <div className="form-group">
                  <label>{translator("EditItem-Code")}</label>{" "}
                  <Tooltip text={translator("Item-Code-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="code"
                    disabled={item.isRawMaterial}
                    defaultValue={item.code}
                    ref={register({
                      maxLength: 10,
                    })}
                  />
                  {errors.code && errors.code.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength10")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-BarCode")}</label>{" "}
                  <Tooltip text={translator("Item-BarCode-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="barCode"
                    disabled={item.isRawMaterial}
                    defaultValue={item.barCode}
                    ref={register({ maxLength: 15 })}
                  />
                  {errors.barCode && errors.barCode.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength15")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-Description")}</label>{" "}
                  <Tooltip text={translator("Item-Description-Msg")} />
                  <textarea
                    style={{ height: "128px" }}
                    id="textArea"
                    className="form-control"
                    name="description"
                    disabled={item.isRawMaterial}
                    defaultValue={item.description}
                    ref={register({
                      maxLength: 250,
                    })}
                  />
                  {errors.description &&
                    errors.description.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                </div>
              </fieldset>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div
              className="container-fluid"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleClose}
              >
                {translator("Btn-Cancel")}
              </button>
              &nbsp;
              <button className="btn btn-primary" type="submit">
                {translator("Btn-Save")}
              </button>
            </div>
          </Modal.Footer>
        </form>
      )}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
      <NullTaxRateModal
        show={showNullTaxRate}
        handleHide={() => {
          setShowNullTaxRate(false);
        }}
        title={translator("NullTaxRate")}
        text={translator("NullTaxRate-TextModal")}
      />

      {/* </CardWrap> */}
    </Modal>
  );
};

export default AddItemModal;
